var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEl10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.3,2.47h9.5l-.28,1.64h-7.64l-.85,4.76h6.64l-.29,1.63h-6.63l-.82,4.63h7.73l-.28,1.63H1.78L4.3,2.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.23,2.47h2l-8.6,14.29h-1.72l-3.56-14.29h1.95l2.88,11.83h.01l7.04-11.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.8,24.96H.79v2.57h-.79v-6.81h2.88c.32,0,.62.05.9.15s.51.25.71.43.35.41.46.67.17.55.17.87c0,.26-.04.49-.11.71s-.17.41-.3.59-.29.32-.47.44-.39.21-.61.28l1.64,2.67h-.91l-1.55-2.57Zm.07-.69c.21,0,.4-.03.58-.1s.33-.16.46-.29.23-.27.31-.45.11-.37.11-.58-.04-.4-.11-.58-.18-.33-.31-.45-.29-.22-.47-.29-.38-.11-.59-.11H.79v2.85h2.08Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m6.07,20.72h4.48v.7h-3.7v2.39h3.22v.69h-3.22v2.33h3.74v.7h-4.53v-6.81Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15.82,25.94h-3.52l-.68,1.59h-.84l2.89-6.81h.77l2.89,6.81h-.84l-.68-1.59Zm-3.23-.69h2.94l-1.44-3.4-.03-.12-.03.12-1.45,3.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m18.02,20.72h2.48c.51,0,.99.08,1.42.23s.81.37,1.13.66.56.65.74,1.07.27.9.27,1.44c0,.51-.08.97-.23,1.39s-.38.78-.68,1.08-.67.53-1.11.7-.94.25-1.51.25h-2.5v-6.81Zm2.46,6.11c.44,0,.84-.06,1.18-.19s.64-.3.87-.54.42-.52.54-.85.18-.7.18-1.12-.06-.76-.17-1.1-.29-.62-.52-.86-.52-.43-.87-.57-.75-.2-1.22-.2h-1.67v5.42h1.67Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m30,20.72l-2.77,4.19v2.62s-.79,0-.79,0v-2.61l-2.77-4.19h.94l2.22,3.47h.01l2.22-3.47h.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEl10);
export default __webpack_public_path__ + "static/media/EL10.e27824c71c3e80581b65a209169ac611.svg";
export { ForwardRef as ReactComponent };